//TODO:开发时isbuild设置为  dev  打包时设为  build
// export const isbuild = 'dev'
export const isbuild = 'build'